import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { useAudio } from "@/context/AudioProvider";
import MobileNowPlayingModal from "@/components/NowPlaying/MobileNowPlayingModal";
import { PLACEHOLDER_ALBUM } from "@/services/mediaService";

const MobilePlayer: React.FC = () => {
  const { state, togglePlay, dispatch } = useAudio();
  const { currentTrack, isPlaying, progress, isLooping, isShuffling } = state;

  const [expanded, setExpanded] = useState(false);

  if (!currentTrack) return null;

  return (
    <>
      {/* Minimized Player */}
      {!expanded && (
        <Box
          sx={{
            position: "fixed",
            bottom: "56px",
            left: 0,
            width: "100%",
            backgroundColor: "#1b1324",
            color: "white",
            padding: "10px 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
          }}
          onClick={() => setExpanded(true)}
        >
          {/* Song Info */}
          <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <Typography variant="body2">
              {currentTrack?.title || "Unknown Title"}
            </Typography>
            <Typography variant="caption">
              {currentTrack?.artistName || "Unknown Artist"}
            </Typography>
          </Box>

          {/* Controls */}
          <IconButton
            sx={{ mx: 0.5 }}
            color="inherit"
            onClick={(e) => {
              e.stopPropagation();
              dispatch({ type: "PREV_TRACK" });
            }}
          >
            <SkipPreviousIcon />
          </IconButton>
          <IconButton
            sx={{ mx: 0.5 }}
            color="inherit"
            onClick={(e) => {
              e.stopPropagation();
              togglePlay();
            }}
          >
            {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
          </IconButton>
          <IconButton
            sx={{ mx: 0.5 }}
            color="inherit"
            onClick={(e) => {
              e.stopPropagation();
              dispatch({ type: "NEXT_TRACK" });
            }}
          >
            <SkipNextIcon />
          </IconButton>

          {/* Expand Button */}
          <IconButton
            color="inherit"
            onClick={(e) => {
              e.stopPropagation();
              setExpanded(true);
            }}
          >
            <ExpandMoreIcon />
          </IconButton>
        </Box>
      )}

      {/* Expanded Player */}
      {expanded && (
        <MobileNowPlayingModal
          track={currentTrack}
          isPlaying={isPlaying}
          progress={progress}
          onClose={() => setExpanded(false)}
        />
      )}
    </>
  );
};

export default MobilePlayer;










